import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { LocaleService } from '../../../../../modules/src/lib/advanced-auth/services/locale.service';
import { AuthService } from '@auth0/auth0-angular';
import { CacheStorageService } from '../../../../../modules/src/lib/core/services/cache-storage.service';

@Component({
  selector: 'app-logged-out',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class LogoutComponent implements OnInit {

  constructor(private auth: AuthService, private localeService: LocaleService, private readonly router: Router, private readonly cacheStorageService: CacheStorageService) {
  }

  async ngOnInit(): Promise<void> {
    this.localeService.removeLocaleForUser();
    await this.cacheStorageService.clear();
    this.auth.logout({
      logoutParams: {
        returnTo: window.location.origin + '/logged-out',
      },
    });
  }

}
